<template>
  <div>
    <el-dialog
      title="选择模块"
      :visible.sync="openCardDialog"
      width="30%">
     <div>
       <el-input style="width: 100%" size="small" v-model="input" placeholder="宽度"></el-input>
       <div class="modular">
         <el-radio v-model="openRadio" :label="1">组织机构</el-radio>
       </div>
       <div class="modular">
         <el-radio v-model="openRadio" :label="2">大事纪要</el-radio>
       </div>
       <div class="modular">
         <el-radio v-model="openRadio" :label="3">应用资源</el-radio>
       </div>
       <div class="modular">
         <el-radio v-model="openRadio" :label="4">简介和视频</el-radio>
       </div>
       <div class="modular">
         <el-radio v-model="openRadio" :label="5">视频轮播</el-radio>
       </div>
     </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="cancel">取 消</el-button>
        <el-button size="small" type="primary" @click="determine">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "editLogo",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    radio: {
      type: [Number,String],
      required:true
    }
  },
  data() {
    return {
      dialogImageUrl: '',
      dialogVisible: false,
      input:30
    };
  },
  watch:{
    radio:{
      handler(oldVal) {
        console.log(oldVal,5111);
      },
      deep:true,
      immediate:true
    }
  },
  computed: {
    openCardDialog: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    },
    openRadio: {
      get() {
        return this.radio
      },
      set(val) {
        this.$emit('update:radio', val)
      }
    }
  },
  methods:{
    // 取消
    cancel() {
      this.$emit('cancelOperation')
    },
    // 确定
    determine() {
      this.$emit('determineOperation',this.input)
    }
  }
}
</script>

<style scoped>
.modular {
  padding: 10px;
  border: 1px solid #eaeaea;
  margin-top: 10px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.modular:nth-child(1) {
  margin-top: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/pageConfig/operation.vue